// ============================================================================
// Table Columns: RuleSets
// Key: ruleSets
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	CustomPropertyRuleSetDto,
	CustomPropertySummary,
	RuleSetSummary,
} from '../api/backstage.schemas'
import { CustomPropertyLinkRuleType } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const ruleSetsListColumnsConfig = {
	columns: [
		'name',
		'description',
		cellRenderer('color', 'color'),
		cellRenderer('tabColor', 'color'),
		cellRenderer('contactColor', 'color'),
		cellRenderer('italic', 'boolean'),
		cellRenderer('bold', 'boolean'),
		cellRenderer('underline', 'boolean'),
		cellRenderer('isHidden', 'boolean'),
		'replaceValue',
		enumRenderer(
			'link',
			CustomPropertyLinkRuleType,
			'CustomPropertyLinkRuleType',
		),
		'linkDisplayName',
		cellRenderer('openContactDetailBeforeAccepting', 'boolean'),
		cellRenderer('hideValue', 'boolean'),
		cellRenderer('showInSplit', 'boolean'),
		'maxWidth',
		'minWidth',
		cellRenderer('customPropertyCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: RuleSetSummary) => `/ruleSets/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<RuleSetSummary>
// #endregion

// #region Relation List Columns
// #region Relation: CustomProperties
export const ruleSetsRelationsCustomPropertiesAssignedColumnsConfig = {
	columns: ['ruleSetName', 'ruleSetDescription', 'customPropertyName'],
} as const satisfies EntityTableConfig<CustomPropertyRuleSetDto>
export const ruleSetsRelationsCustomPropertiesAvailableColumnsConfig = {
	columns: [
		'key',
		'keyDisplayName',
		cellRenderer('sortOrder', 'number'),
		cellRenderer('hidden', 'boolean'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		cellRenderer('ruleSetsCount', 'number'),
	],
} as const satisfies EntityTableConfig<CustomPropertySummary>
// #endregion
// #endregion

// #region Columns Config Export
export const ruleSetsColumnsConfig = {
	list: ruleSetsListColumnsConfig,
	relations: {
		customProperties: {
			assigned: ruleSetsRelationsCustomPropertiesAssignedColumnsConfig,
			available: ruleSetsRelationsCustomPropertiesAvailableColumnsConfig,
		},
	},
} as const
// #endregion
